"use client";

import { deleteCookie, getCookie, setCookieWithMaxAge } from "@/utils/cookies";

export const TIER2_CRISIS_COOKIE_KEY = "tier2CrisisState";
const TIER2_CRISIS_COOKIE_TTL_SECONDS = 60 * 5;

export interface Tier2CrisisCookiePayload {
  chatId: string;
  tier: "2";
  type: "chat" | "wellness" | string;
  createdAt: string;
}

export function persistTier2CrisisCookie(
  payload: Omit<Tier2CrisisCookiePayload, "createdAt">,
): void {
  if (!payload.chatId || payload.tier !== "2" || !payload.type) {
    return;
  }

  setCookieWithMaxAge(
    TIER2_CRISIS_COOKIE_KEY,
    JSON.stringify({
      ...payload,
      createdAt: new Date().toISOString(),
    }),
    TIER2_CRISIS_COOKIE_TTL_SECONDS,
  );
}

export function readTier2CrisisCookie(): Tier2CrisisCookiePayload | null {
  const rawValue = getCookie(TIER2_CRISIS_COOKIE_KEY);

  if (!rawValue) {
    return null;
  }

  try {
    const parsed = JSON.parse(rawValue) as Partial<Tier2CrisisCookiePayload>;

    if (
      typeof parsed.chatId !== "string" ||
      !parsed.chatId ||
      parsed.tier !== "2" ||
      typeof parsed.type !== "string" ||
      !parsed.type
    ) {
      return null;
    }

    return {
      chatId: parsed.chatId,
      tier: "2",
      type: parsed.type,
      createdAt:
        typeof parsed.createdAt === "string"
          ? parsed.createdAt
          : new Date().toISOString(),
    };
  } catch {
    return null;
  }
}

export function clearTier2CrisisCookie(): void {
  deleteCookie(TIER2_CRISIS_COOKIE_KEY);
}
